// The signed-in account has no employee record linked on the payroll side, so there is
// no pay to show. A set-up state HR fixes — deliberately NOT the error look (no red icon,
// no Retry: retrying can never change the answer) and NOT "no payslips yet" (which would
// claim the person is on payroll and simply hasn't been paid).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserX } from 'lucide-react';

export const NotLinkedState: React.FC<{ compact?: boolean }> = ({ compact }) => {
  const { t } = useTranslation('payroll');
  return (
    <div
      role="status"
      data-testid="mypay-not-linked"
      className={`flex flex-col items-center justify-center gap-2 text-center ${compact ? 'py-12' : 'py-20'}`}
    >
      <UserX className="h-10 w-10 text-muted-foreground" aria-hidden />
      <p className="font-medium text-charcoal">
        {t('myPay.notLinkedTitle', { defaultValue: 'Your account isn’t linked to an employee record yet' })}
      </p>
      <p className="max-w-md text-sm text-muted-foreground">
        {t('myPay.notLinkedBody', {
          defaultValue: 'Ask HR to link it — your payslips and pay details will appear here once it is.',
        })}
      </p>
    </div>
  );
};
